module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/cookies");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/config");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/request");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/utils/static");

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);
/* harmony import */ var smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_3__);




var apiFile = {
  extend: function extend(apiName, path) {
    apiFile[apiName] = function (params) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Object(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__["onSync"])(path, params, config);
    };
  },

  /**
   * @description: 获取多个文件信息--用于文章关联的文件
   * @param n*o fileIds
   * @return n*o
   */
  getListForWeChat: function getListForWeChat(_ref) {
    var _ref$fileIds = _ref.fileIds,
        fileIds = _ref$fileIds === void 0 ? [] : _ref$fileIds;
    return Object(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__["onSync"])("/file/getListForWeChat", {
      fileIds: fileIds
    });
  },

  /**
   * @description: 通过邮箱下载文件
   * @param n*o
   * @return n*o
   */
  downloadWithEmail: function downloadWithEmail(_ref2) {
    var _ref2$articleId = _ref2.articleId,
        articleId = _ref2$articleId === void 0 ? 0 : _ref2$articleId,
        _ref2$fileList = _ref2.fileList,
        fileList = _ref2$fileList === void 0 ? [] : _ref2$fileList,
        email = _ref2.email,
        _ref2$forEmailTemp = _ref2.forEmailTemp,
        forEmailTemp = _ref2$forEmailTemp === void 0 ? 0 : _ref2$forEmailTemp,
        _ref2$referenceUrl = _ref2.referenceUrl,
        referenceUrl = _ref2$referenceUrl === void 0 ? document.referrer : _ref2$referenceUrl,
        moduleType = _ref2.moduleType,
        instanceId = _ref2.instanceId,
        _ref2$browseInfo = _ref2.browseInfo,
        browseInfo = _ref2$browseInfo === void 0 ? {} : _ref2$browseInfo;
    return smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_3___default.a.postJson('/file/downloadWithEmail', {
      articleId: articleId,
      email: email,
      globalUserId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_2___default.a.globalUserId(),
      url: window.location.href,
      referenceUrl: referenceUrl,
      forEmailTemp: forEmailTemp,
      moduleType: moduleType,
      instanceId: instanceId,
      browseInfo: browseInfo,
      sess: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_2___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('schemaId')) && smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_2___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('schemaId')).session,
      openId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_2___default.a.openId(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('weChatId')),
      fileList: fileList
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (apiFile);

/***/ })
/******/ ]);